/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Font_SizeInputs */

const en_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captioner font size`)
};

const fr_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`taille de la police du sous-titre`)
};

const de_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße für Untertitel`)
};

const it_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione del carattere della didascalia`)
};

const ru_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`размер шрифта в редакторе подписей`)
};

const es_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente del subtitulador`)
};

const zh_cn2_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕字体大小`)
};

const ja_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションのフォントサイズ`)
};

const hi_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शनर फ़ॉन्ट आकार`)
};

const pt_pt2_live_caption_font_size = /** @type {(inputs: Live_Caption_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tamanho da fonte do legendador`)
};

/**
* | output |
* | --- |
* | "Captioner font size" |
*
* @param {Live_Caption_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_font_size = /** @type {((inputs?: Live_Caption_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_font_size(inputs)
	if (locale === "de") return de_live_caption_font_size(inputs)
	if (locale === "it") return it_live_caption_font_size(inputs)
	if (locale === "ru") return ru_live_caption_font_size(inputs)
	if (locale === "es") return es_live_caption_font_size(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_font_size(inputs)
	if (locale === "ja") return ja_live_caption_font_size(inputs)
	if (locale === "hi") return hi_live_caption_font_size(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_font_size(inputs)
	return en_live_caption_font_size(inputs)
});